export const getHeadingTag = headingLevel => {
  if (!Number.isInteger(headingLevel) || headingLevel < 1) {
    return 'h2';
  }

  if (headingLevel > 6) {
    return 'h6';
  }

  return `h${headingLevel}`;
};
